module.exports = __webpack_public_path__ + "static/img/186_phase_function_Paper_PointsHejduk_Prediction.82c7d12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/186_phase_function_Paper_PointsHejduk_Prediction.png
// module id = M9Q4
// module chunks = 0